import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/css/index.scss'
import Header from './components/Header.vue'
import { Swipe, SwipeItem } from 'vant';
import 'vant/lib/index.css';

const app = createApp(App)
app.use(router)
app.use(ElementPlus)
app.component('Header', Header)
app.use(Swipe).use(SwipeItem)
app.mount('#app')